<template>
  <b-form
    novalidate
    autocomplete="off"
    class="filters"
  >
    <ul
      :class="['filters__list', listClass]"
    >
      <li
        v-for="(id, index) in items"
        :key="index"
        :class="['filters__block', itemClass]"
      >
        <slot :name="id" />
      </li>
    </ul>
    <div class="filters__reset">
      <btn
        transparent
        variant="link"
        class="filters__reset-button"
        @click="onClickReset"
        v-html="$t('button.reset')"
      />
    </div>
  </b-form>
</template>

<script>
  import Btn from '@components/Btn/Btn';
  import { BForm } from 'bootstrap-vue';

  export default {
    name: 'FilterList',
    components: {
      Btn,
      BForm
    },
    props: {
      /**
       * Array of filters
       */
      items: {
        type: Array,
        default: () => []
      },
      /**
       * Class for list tag
       */
      listClass: {
        type: String,
        default: ''
      },
      /**
       * Class for item tag
       */
      itemClass: {
        type: String,
        default: ''
      }
    },
    methods: {
      /**
       * Emits the reset event
       * @event onClickReset
       * @type {Click}
       */
      onClickReset() {
        this.$emit('reset');
      }
    }
  };
</script>

<style lang="scss" scoped>
  @import './FilterList';
</style>
